import FaceScanCircle from '@/images/FaceScanCircle.svg';
import Videocamera from '@/images/Videocamera.svg';
import Volume from '@/images/Volume.svg';
import { AvatarType } from '@/pages/avatar/common';

export interface FootageRequirementProps {
    icon: string;
    text: string;
    confirmed: boolean;
    avatarType?: AvatarType;
    testId?: string;
}

export enum FootageRequirement {
    FACE_VISIBLE = 'FACE_VISIBLE',
    QUIET_ENVIRONMENT = 'QUIET_ENVIRONMENT',
    SILENT_VIDEO_RECORDED = 'SILENT_VIDEO_RECORDED',
}

// TODO: consider delete
const getTestId = (requirement: FootageRequirement) => `footage-requirement-${requirement}`;

export const SAFE_ZONE_FACE_VISIBLE_TEXT = 'My face visible within the guides at all times';

export const requirementsMap: Record<FootageRequirement, FootageRequirementProps> = {
    [FootageRequirement.FACE_VISIBLE]: {
        icon: FaceScanCircle,
        text: 'My face is visible at all times and I’m looking directly at the camera',
        confirmed: false,
        testId: getTestId(FootageRequirement.FACE_VISIBLE),
    },

    [FootageRequirement.QUIET_ENVIRONMENT]: {
        icon: Volume,
        text: 'The environment is quiet and well lit',
        confirmed: false,
        testId: getTestId(FootageRequirement.QUIET_ENVIRONMENT),
    },

    [FootageRequirement.SILENT_VIDEO_RECORDED]: {
        icon: Videocamera,
        text: "I've recorded a 30 seconds of silent state",
        confirmed: false,
        avatarType: AvatarType.PremiumPlus,
        testId: getTestId(FootageRequirement.SILENT_VIDEO_RECORDED),
    },
};
